import { mapGetters, mapActions } from 'vuex';
import Alerts from '@/components/alert-notifications/alert-notifications';
import auth from '@/api/auth';

export default {

  computed: {
    ...mapGetters(['alert', 'isAuthenticated']),
  },

  components: {
    alerts: Alerts,
  },

  methods: {
    ...mapActions(['LOGIN_REQUEST', 'ALERT_HIDE']),

    login() {
      auth.login(this.auth);
    },
  },

  mounted() {
    this.auth = auth.initCognitoAuth();

    if (this.isAuthenticated) {
      this.$router.push({ name: 'dashboard' });
    }
  },
};
